import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { EventConstant } from '../../../../../sse/event.constant';
import { ApprovedOrRejectedSrEvent } from '../../../../../pages/v2/notifications/interfaces/approved-or-rejected-sr-event.interface';
import { first, Subscription } from 'rxjs';
import { NotificationsService } from '@services/notifications.service';
import { NotificationMessagesService } from '@modules/notification-messages/services/notification-messages.service';
import { NotificationService as TooltipService } from '@notification/service';
import { SignalrService } from '../../../../../sse/signalr.service';
import { NotifyItirenaryReadyEvent } from 'src/app/pages/v2/notifications/interfaces/notify-itirenary-event';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-notification-messages',
  template: ``,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationMessagesComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly notificationsService: NotificationsService,
    private readonly notificationsSharedService: NotificationMessagesService,
    private readonly tooltipService: TooltipService,
    private readonly signalrService: SignalrService
  ) {}

  ngOnInit(): void {
    this.signalrEventWatcher();
    this.getUnreadNotificationsCount();
  }

  ngOnDestroy(): void {
    this.signalrService.removeEventListener(EventConstant.serviceRequestApprovedOrRejectedEvent);
    this.signalrService.removeEventListener(EventConstant.itineraryReadyEvent);
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  private signalrEventWatcher(): void {
    this.signalrService.sseEventListener(EventConstant.serviceRequestApprovedOrRejectedEvent);
    this.signalrService.sseEventListener(EventConstant.itineraryReadyEvent);

    const eventDataChangeSub = this.signalrService.eventDataChange.subscribe((value) => {
      if (value.eventName === EventConstant.serviceRequestApprovedOrRejectedEvent) {
        this.onApprovedOrRejectEvent(value.data as ApprovedOrRejectedSrEvent);
      }
      if (value.eventName === EventConstant.itineraryReadyEvent) {
        this.onItineraryReadyEvent(value.data as NotifyItirenaryReadyEvent);
      }
    });

    this.subscriptions.push(eventDataChangeSub);
  }

  private onItineraryReadyEvent(data: NotifyItirenaryReadyEvent): void {
    this.tooltipService.success(data.Message, data.Title, environment.redirectUri + '/#/v2/service-request-details/' + data.ServiceRequestId, data.NotificationId);
    this.getUnreadNotificationsCount();
  }

  private onApprovedOrRejectEvent(data: ApprovedOrRejectedSrEvent): void {
    if (data.isApproved === 'true') {
      this.tooltipService.success(data.description, data.title);
    } else {
      this.tooltipService.error(data.description, data.title);
    }

    this.getUnreadNotificationsCount();
  }

  private getUnreadNotificationsCount(): void {
    this.notificationsService.getUnreadNotificationsCount()
      .pipe(first())
      .subscribe((response: number): void => {
        this.notificationsSharedService.recountNotificationsEvent.next(response);
      });
  }
}
